import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider, ContentChild } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { SplitButton } from '@syncfusion/ej2-splitbuttons';

import { SplitButtonItemsDirective } from './items.directive';

export const /** @type {?} */ inputs: string[] = ['content','cssClass','disabled','enableHtmlSanitizer','enablePersistence','enableRtl','iconCss','iconPosition','items','locale','target'];
export const /** @type {?} */ outputs: string[] = ['beforeClose','beforeItemRender','beforeOpen','click','close','created','open','select'];
export const /** @type {?} */ twoWays: string[] = [];
/**
 * Represents the Angular SplitButton Component.
 * ```html
 * <ejs-splitbutton content='Split Button'></ejs-splitbutton>
 * ```
 */
@ComponentMixins([ComponentBase])
export class SplitButtonComponent extends SplitButton implements IComponentBase {
public containerContext : any;
public tagObjects: any;
public childItems: QueryList<SplitButtonItemsDirective>;
public tags: string[] = ['items'];
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        this.tagObjects[0].instance = this.childItems;
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-splitbutton',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content ></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {
        childItems: new ContentChild(SplitButtonItemsDirective)
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function SplitButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
SplitButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitButtonComponent.ctorParameters;
/** @type {?} */
SplitButtonComponent.prototype.containerContext;
/** @type {?} */
SplitButtonComponent.prototype.tagObjects;
/** @type {?} */
SplitButtonComponent.prototype.childItems;
/** @type {?} */
SplitButtonComponent.prototype.tags;
/** @type {?} */
SplitButtonComponent.prototype.registerEvents;
/** @type {?} */
SplitButtonComponent.prototype.addTwoWay;
/** @type {?} */
SplitButtonComponent.prototype.ngEle;
/** @type {?} */
SplitButtonComponent.prototype.srenderer;
/** @type {?} */
SplitButtonComponent.prototype.viewContainerRef;
/** @type {?} */
SplitButtonComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
